import _extends from "@babel/runtime/helpers/extends";
import MuiListItemAvatar from "@material-ui/core/ListItemAvatar";
import classNames from "classnames";
import React from "react";
export const ListItemAvatar = ({
  className,
  ...otherProps
}) => {
  return /*#__PURE__*/React.createElement(MuiListItemAvatar, _extends({}, otherProps, {
    className: classNames("prmbl-listItemAvatar", className)
  }));
};
export default ListItemAvatar;